import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const UpdateGroupsOwnerModalContext = createContext<ContextType | null>(null);

const UpdateGroupsOwnerModalProvider: ComponentWithChildren = ({
  children,
}) => {
  const providerValue = useProviderValue();

  return (
    <UpdateGroupsOwnerModalContext.Provider value={providerValue}>
      {children}
    </UpdateGroupsOwnerModalContext.Provider>
  );
};

export const useUpdateDonorsOwnerModalContext = () => {
  const context = useContext(UpdateGroupsOwnerModalContext);
  if (context === undefined) {
    throw new Error(
      'the useUpdateGroupsOwnerModalContext should be used within UpdateGroupsOwnerModalContextProvider!'
    );
  }

  return context;
};

export default UpdateGroupsOwnerModalProvider;
